export default __webpack_public_path__ + "static/media/logo_biscoint.b3efceae.png";